<template>
    <section v-if="loaded" class="alerts-panel">
        <p v-if="alarmActive && alerts.length === 0">
            <i class="fa fa-check text-success"></i> {{$t('message.alarms_active')}}
        </p>
        <p v-if="!alarmActive">
            {{$t('message.alarms_inactive')}}
            <i class="fa fa-bell-o"></i>
        </p>
        <div v-if="alerts.length > 0" class="alerts-table-wrap">
            <table class="alerts-table">
                <tr v-for="a in alerts" :key="a.id" role="alert">
                    <td class="alerts-col-date text-grey text-clickable" @click="showDay(a.createdAt)">{{a.createdAt}}</td>
                    <td class="alerts-col-message text-bold">
                        <i class="fa fa-exclamation-triangle text-red-600"></i>
                        {{a.message}}
                    </td>
                    <td class="alerts-col-path text-grey">{{a.path}}</td>
                    <td class="alerts-col-action">
                        <b-btn size="sm" @click.prevent="archive(a)">{{$t('message.archive')}}</b-btn>
                    </td>
                </tr>
            </table>
        </div>
        <div v-if="alertsCount > 0" class="alerts-actions">
            <b-btn type="primary" @click="archiveAll">{{$t('message.archive_all')}}</b-btn>
            <router-link class="btn btn-default" to="/alarms">{{$t('message.all_alarms')}}</router-link>
        </div>
    </section>
</template>

<script>
    import {ALERT_REQUEST} from '../../_store'
    import eventBus from '../../modules/eventBus'
    export default {
        name: 'Alerts',
        data () {
            return {
                alerts: [],
                alarmActive: false,
                alertsCount: 0,
                loaded: false
            }
        },
        methods: {
            showDay (day) {
                let date = day.split(' ')
                const req = {
                    date: date[0],
                    period: 'day',
                    source: 'alerts'
                }
                eventBus.emit('change', req)
                eventBus.emit('focus-date', req)
            },
            archive (alert) {
                this.alerts.splice(this.alerts.indexOf(alert), 1)
                this.$store.dispatch(ALERT_REQUEST, {action: 'update', id: alert.id, request: {archive: true}})
                    .then(resp => {

                    })
            },
            archiveAll (alert) {
                this.$store.dispatch(ALERT_REQUEST, {action: 'update', request: {archive: true}})
                    .then(resp => {
                        this.load();
                    })
            },
            load () {
                this.$store.dispatch(ALERT_REQUEST, {action: 'read', limit: 10})
                    .then(resp => {
                        this.loaded = true
                        this.alarmActive = resp.data.alarms
                        const list = resp.data.alerts
                        this.alerts = Array.isArray(list) ? list : Object.values(list || {})
                        this.alertsCount = resp.data.alertsCount
                    })
            }
        },
        created () {
            this.load()
            this.stopReloadAlertsListener = eventBus.on('reload-alerts', () => {
                this.load()
            })
        },
        beforeUnmount () {
            this.stopReloadAlertsListener()
        }
    }
</script>

<style scoped>
    .alerts-panel {
        width: 100%;
        margin-bottom: 1.25rem;
        padding: 1rem;
        border: 1px solid #e5e7eb;
        border-radius: 4px;
        background: #fff;
    }
    .alerts-table-wrap {
        width: 100%;
        overflow-x: auto;
    }
    .alerts-table {
        width: 100%;
        max-width: none;
        border-collapse: collapse;
        table-layout: auto;
    }
    .alerts-table tr {
        border-bottom: 1px solid #e5e7eb;
    }
    .alerts-table td {
        padding: 0.4rem 0.75rem 0.4rem 0;
        vertical-align: middle;
        font-size: 0.875rem;
        line-height: 1.35;
    }
    .alerts-col-date {
        width: 1%;
        white-space: nowrap;
        padding-right: 1rem;
    }
    .alerts-col-message {
        width: 42%;
        padding-right: 1rem;
    }
    .alerts-col-path {
        width: auto;
        padding-right: 1rem;
    }
    .alerts-col-action {
        width: 1%;
        white-space: nowrap;
        text-align: right;
        padding-right: 0;
    }
    .alerts-actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.5rem;
        margin-top: 0.75rem;
    }
    .text-bold {
        font-weight: 600;
    }
    .text-grey {
        color: #8c8c8c;
    }
    .text-clickable {
        cursor: pointer;
    }
</style>
